import { push } from "connected-react-router";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ROUTE_PATH } from "../../app/constants";
import {
  Header,
  Paragraph,
  Button,
  ErrorMark,
  NavigationLinkButton,
} from "../../components/RegularComponents";
import CheckboxForm from "../../components/CheckBoxForm";
import TopNavigationBar from "../TopNavigationBar";
import {
  setMortgageProperty,
} from "../../redux/slice/primaryAgencyApplicationSlice";
import { ERROR_STRING } from "../../app/errors";

const MORTGAGE_APPLICATION_PROPERTY = "confirmBusinessInformation";

export const ConfirmBusinessInformation = (props) => {
  const dispatch = useDispatch();
  const [confirmCheck, setConfirmCheck] = useState(false);
  const [showValidationError, setShowValidationError] = useState(false);

  // Note: we will pull information out of mraApplicationState when we get the forms setup
  const mraApplicationState = useSelector( (state) => state.primaryAgencyApplication.application.businessLicenceData);

  console.log("Do we got anything in state?", mraApplicationState);

  return (
    <>
      <div className={"container"}>
        <TopNavigationBar {...props} />
        <div className="row">
          <div className="col-xs-12 col-lg-9">
            <Header
              id="confirm-business-information-header"
              header="Confirm business information"
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-lg-9">
            If your business information is out of date, you must update it with
            the
            <NavigationLinkButton
              id={"rjsc-link"}
              text={"Registry of Joint Stock Companies (RJSC)"}
              onClick={() => {
                dispatch(
                  push({
                    pathname: `${ROUTE_PATH.MRA_APP}`,
                  })
                );
              }}
            />{" "}
            before you continue the application
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-lg-9">
            <Paragraph
              id="complete-business-information-text"
              text={[
                "<h3>Company Information</h3>",
                "<b>Legal Business Name</b>&nbsp;&nbsp;&nbsp;&nbsp;<i>Legal Business Name here</i>",
                "<b>Operating Name</b>&nbsp;&nbsp;&nbsp;&nbsp;<i>Operating Name here</i>",
                "<b>RJSC Number</b>&nbsp;&nbsp;&nbsp;&nbsp;<i>RJSC Number here</i>",
                "<b>Registered Office</b>&nbsp;&nbsp;&nbsp;&nbsp;<i>Registered Office here</i>",
                "<b>Mailing Office</b>&nbsp;&nbsp;&nbsp;&nbsp;<i>Mailing Office here</i>",
                "<hr/>",
              ]}
            />
          </div>
        </div>
        {/*May need to map individuals if not static*/}
        <div className="row">
          <div className="col-xs-12 col-lg-6">
            <Paragraph
              id="complete-business-information-text"
              text={[
                "<h3>Individuals listed under RJSC</h3>",
                "<b>Name</b>&nbsp;&nbsp;&nbsp;&nbsp;<i>Name 1 here</i>",
                "<b>Relationship</b>&nbsp;&nbsp;&nbsp;&nbsp;<i>Relationship 1 here</i>",
                "<hr/>",
                "<b>Name</b>&nbsp;&nbsp;&nbsp;&nbsp;<i>Name 2 here</i>",
                "<b>Relationship</b>&nbsp;&nbsp;&nbsp;&nbsp;<i>Relationship 2 here</i>",
                "<hr/>",
                "<b>Name</b>&nbsp;&nbsp;&nbsp;&nbsp;<i>Name 3 here</i>",
                "<b>Relationship</b>&nbsp;&nbsp;&nbsp;&nbsp;<i>Relationship 3 here</i>",
              ]}
            />
          </div>
          <div className="col-xs-12 col-lg-9">
            <hr />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-lg-9">
            <Paragraph
              id="complete-business-information-text"
              text={[
                "<h2>Principal broker must be one of the individuals above.</h2>",
                "As a principal broker for your company, you have to be listed as a director, partner, officer, or sole proprietor with the Registry of Joint Stock Companies.  If your name isn't on the list, you will need to update your company's profile on RJSC.",
              ]}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-lg-9">
            <CheckboxForm
              id="confirm-business-information-checkbox"
              checked={confirmCheck}
              value={confirmCheck}
              labelText="Yes, my name is on the list above."
              onCheckBoxChange={(val) => {
                setShowValidationError(false);
                setConfirmCheck(val);
              }}
            />
          </div>
        </div>

        <div className="row">
          <div
            className={"col-lg-2" + (showValidationError ? " has-error" : "")}
          >
            <Button
              id="complete-mortgage-education-continue-button"
              style={{ margin: "0 10px 10px 0" }}
              buttonType={"regular_primary"}
              text={"Save and next"}
              onClick={() => {
                if (!confirmCheck) {
                  setShowValidationError(true);
                  return;
                }

                setShowValidationError(false);

                // Set MORTGAGE PROP value
                dispatch(
                  setMortgageProperty({
                    key: MORTGAGE_APPLICATION_PROPERTY,
                    value: true,
                  })
                );

                // On to the next item
                dispatch(
                  push(`${ROUTE_PATH.MRA_APP}${ROUTE_PATH.MRA_IS_NINETEEN_NO}`)
                );
              }}
            />
            {showValidationError && ErrorMark()}
            {showValidationError && (
              <div className="ns-error-message">
                <span className="ns-visually-hidden">Error:</span>
                {ERROR_STRING.CONFIRM_MORTGAGE_EDUCATION_REQUIREMENT}
              </div>
            )}
          </div>
          <div className="col-lg-8">
            <NavigationLinkButton
              id={"outdated-info-rjsc-link"}
              text={"Update outdated information in RJSC"}
              onClick={() => {
                dispatch(
                  push({
                    pathname: `${ROUTE_PATH.MRA_APP}`,
                  })
                );
              }}
            />{" "}
          </div>
        </div>
      </div>
    </>
  );
};
